import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { guideCards } from '@/mocks/homeData';

interface GuidesSectionProps {
  lang: string;
}

export default function GuidesSection({ lang }: GuidesSectionProps) {
  const { t } = useTranslation();

  const iconMap: Record<string, string> = {
    'allchinabuy-spreadsheet-guide': 'ri-file-list-3-line',
    'allchinabuy-review': 'ri-star-line',
    'allchinabuy-shipping-cost': 'ri-truck-line',
    'allchinabuy-coupon': 'ri-coupon-line',
    'allchinabuy-discount-code': 'ri-percent-line',
    'allchinabuy-warehouse': 'ri-archive-line',
    'is-allchinabuy-legit': 'ri-shield-check-line',
    'allchinabuy-qc-guide': 'ri-camera-line',
    'how-to-order-allchinabuy': 'ri-shopping-cart-line',
    'allchinabuy-buying-guide': 'ri-compass-line',
  };

  return (
    <section id="guides" className="w-full bg-background-100 py-16 md:py-24">
      <div className="section-container">
        <div className="section-inner">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4 font-heading">
              {t('guides_title')}
            </h2>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {guideCards.map((guide, idx) => (
              <Link
                key={guide.slug}
                to={`/${lang}/article/${guide.slug}`}
                className="group p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 hover:shadow-md transition-all cursor-pointer"
              >
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                  <i className={`${iconMap[guide.slug] || 'ri-file-text-line'} text-lg md:text-xl text-primary-600`} />
                </div>
                <h3 className="font-semibold text-foreground-950 mb-2 group-hover:text-primary-700 transition-colors">
                  {t(guide.titleKey)}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3 mb-4">
                  {guide.desc}
                </p>
                <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                  {t('guide_read')}
                  <i className="ri-arrow-right-line text-xs" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}